module.exports = __webpack_public_path__ + "media/warehouse_by_volume/img-size6m-6f6724f6.png";